import { ClaimCorrectionNoteResponse, MedicalNoteForm, updateClaimCorrectionNote } from '@uplift/api';
import { ClaimCorrectionFormType } from '@uplift/types';
import { isAxiosError } from 'axios';

type ClaimCorrectionError = {
  error: {
    msg?: string;
    code: string;
    form?: MedicalNoteForm;
  };
};

type ClaimCorrectionResponse =
  | ClaimCorrectionNoteResponse
  | {
    error: string;
    message?: string;
    form?: MedicalNoteForm;
  };

export const patchClaimCorrection = async (noteId: string, values: ClaimCorrectionFormType, cptCodes: string[]): Promise<ClaimCorrectionResponse> => {
  try {
    return await updateClaimCorrectionNote(noteId, {
      claimCorrectionNoteForm: values.claim,
      diagnosisIds: values.diagnosis,
      cptCodeIds: cptCodes.length > 0 ? cptCodes : undefined
    });
  } catch (error) {
    if (isAxiosError<ClaimCorrectionError>(error)) {
      return {
        error: error.response.data.error.code,
        message: error.response.data.error.msg ? error.response.data.error.msg : undefined,
        form: error.response.data.error.form ? error.response.data.error.form : undefined
      };
    }
  }
};
